import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { toastFactory } from '@/factories'
import { resetQueries } from '@/utils/api'
import { getApiErrorMessage } from '@/utils/error'

type UnarchivePackageRequest = {
  id: number
}

type UseUnarchivePackageOptions = {
  onSuccess?: () => void
}

export const unarchivePackage = async (data: UnarchivePackageRequest): Promise<void> => {
  await authAPI.put(`/packages/${data.id}/unarchive`)
}

export const useUnarchivePackage = ({ onSuccess }: UseUnarchivePackageOptions = {}) => {
  return useMutation({
    mutationFn: unarchivePackage,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
      toastFactory.success('Package was successfully unarchived')
      onSuccess?.()
    },
  })
}
